<template>
    <v-container fluid>
       
       <v-alert type="info"  dismissable value="true" v-if="!permission">You do not have permission to edit this page</v-alert>
       <v-alert type="info"  dismissable value="true" v-if="metadata.info">{{ metadata.info }}</v-alert>
       <v-alert type="warn"  dismissable value="true" v-if="metadata.warn">{{ metadata.warn }}</v-alert>
       <v-alert type="error" dismissable value="true" v-if="metadata.error">{{ metadata.error }}</v-alert>


       <form id="importForm" v-on:submit.prevent>

           <v-card class="no-print d-none d-md-flex">
               <v-btn v-on:click="downloadTemplate()"><v-icon>download</v-icon> Download Template</v-btn>
               <v-btn class="ml-1 ies-coral" v-on:click="resetForm()" v-if="permission"><v-icon>cancel</v-icon> Reset</v-btn>
               <v-btn class="ml-1" v-on:click="listView()"><v-icon>view_list</v-icon> List</v-btn>
               <v-btn class="ml-1" v-on:click="emailLink()"><v-icon>email</v-icon> Email</v-btn>
               <v-btn class="ml-1" v-on:click="reportProblem()"><v-icon>report_problem</v-icon> Problem</v-btn>
           </v-card>


           <v-card class="mt-3">
              <v-card-text>
                <v-row class="ma-3" >
                    <v-col cols="12">
                        <h2>Preparing Your Upload</h2>
                        <p class="mt-3">Click the Download Template button, or create your own spreadsheet containing the data you wish to import.  Please note that only .csv files are supported and the first row must contain the field names.  Not all fields are required.  Please check the data in the file before you upload it.  The automated validation cannot be relied upon to find human error.  Once the data has been imported it may be much harder to find and correct mistakes.</p>
                   </v-col>

                    <v-col cols="12">The following fields are supported: </v-col>
                    <v-col v-for="(section,i) in formSections" :key="i" cols="12" sm="12" md="12" :lg="section.sectionWidth ? section.sectionWidth : 12">
                     	<v-card flat class="ma-3">
                        	<fieldset>
                            	<legend v-if="section.sectionName">{{ section.sectionName }}</legend>

                                <v-col cols="12">
                                    <v-alert type="info"  dismissable value="true">
                                        <p>Matches will be found using {{ pageRecord.import_match_field }}</p>
                                        <p>If a match is found then the existing record will be updated.  If no match is found then a new record will be created</p>
                                    </v-alert>
                                </v-col>

                            	<v-alert type="info"  dismissable value="true" v-if="section.info">{{ section.info }}</v-alert>
                            	<v-alert type="warn"  dismissable value="true" v-if="section.warn">{{ section.warn }}</v-alert>
                            	<v-alert type="error" dismissable value="true" v-if="section.error">{{ section.error }}</v-alert>
                                <div v-if="section.introduction">{{ section.introduction }}</div>

                            	<v-row>
                                	<v-col v-for="(field,k) in section.fields" :key="k" cols="12" sm="6" md="4" lg="2">
                                    	{{  fieldInfo(field) }}
                                	</v-col>
                            	</v-row>

                            	<div v-if="section.outroduction">{{ section.outroduction }}</div>
                        	</fieldset>
                     	</v-card>
                    </v-col>
		</v-row>
              </v-card-text>
            </v-card>


            <v-card class="no-print mt-3" v-if="uxStage == 'choose'">
                <v-card-text>
                    <p>Please choose a file to import (.csv)</p>
                </v-card-text>
                <v-card-actions>
                    <input type="file" accept="text/csv" @change="fileSelected($event)">
                    <v-btn class="ies-green" @click="uploadFile"><v-icon>cloud_upload</v-icon> Upload</v-btn>
                </v-card-actions>
            </v-card>

            <v-card class="no-print mt-3" v-if="uxStage == 'confirm'">
                <v-card-text>
                  <v-row class="ma-3" >
                    <v-col cols="12">
                        <h2>Analysis</h2>
                        <p class="mt-3">The following fields were identified in the file:</p>
                    </v-col>

                    <v-col cols="12">
                      <ul>
                          <li v-for="(identifiedField, key) in uploadResponse.identifiedFields" :key="key">'{{ identifiedField.fileFieldName }}' as {{ identifiedField.schema.modelName }} {{ identifiedField.schema.fieldName }}</li>
                      </ul>
                    </v-col>
                    <v-col cols="12">
                        <p>There are {{ uploadResponse.numRecordsFound }} records in the file</p>
                    </v-col>

                    <v-col cols="12">
                        <h2>Sample</h2>
                        <p class="mt-3">Cells in dark grey are not recognised, and will not be imported.  If you expected a field to be imported please check the field heading against the names listed above</p>
                    </v-col>

                    <v-col cols="12">
                    <table class="sample">
                        <tr v-for="(row, rowIndex) in uploadResponse.sample" :class="{'is-headings': rowIndex == 0 }">
                            <td v-for="(cell, cellIndex) in row" :class="{'is-not-relevant': cell.isRelevant == false}">{{ cell.value }}</td>
                        </tr>
                    </table>
                    </v-col>


                    <v-col cols="12">
                    <h2>Validation</h2>

                    <div class="mt-3" v-if="uploadResponse.invalidData.length == 0">The file passed validation</div>

                    <v-alert class="mt-3" type="error"  dismissable value="true" v-if="uploadResponse.invalidData.length > 0">
                        <p>Validation failed with {{ uploadResponse.invalidData.length }} problem{{ uploadResponse.invalidData.length === 1 ? '' : 's'}}.  Please correct the problems identified below and resubmit the file</p>
                    </v-alert>

                    <div v-if="uploadResponse.invalidData.length > 0">
                        <table class="sample">
                            <tr class="is-headings">
                              <td>Record</td>
                              <td v-for="(cell, cellIndex) in uploadResponse.sample[0]" :class="{'is-not-relevant': cell.isRelevant == false}">{{ cell.value }}</td>
                            </tr>

                            <tr v-for="(row, rowIndex) in uploadResponse.invalidData">
                                <td>{{ row.rowIndex + 1 }}</td>
                                <td v-for="(cell, cellIndex) in row.cells" :class="{'is-invalid': cell.isValid == false}">{{ cell.value }} <div v-if="cell.isValid == false">(<span v-for="(error, errorIndex) in cell.errors">{{ error.reason }}</span>)</div></td>
                            </tr>
                        </table>
                    </div>

                    <div v-if="uploadResponse.invalidData.length == 0">If this is what you expected to see then you can continue to import the data to the database using the controls below</div>

                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-btn @click="resetForm">Upload New File</v-btn>
                    <v-btn class="ies-green" 
                           @click="confirmImport" 
                           :disabled="uploadResponse.invalidData.length > 0">Import This Data</v-btn>
                </v-card-actions>
            </v-card>

            <v-card class="no-print mt-3" v-if="uxStage == 'complete'">
                <v-card-text>
                    The data file will now be imported.  This may take a few minutes
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="resetForm">Upload New File</v-btn>
                    <v-btn class="ies-green" v-on:click="listView()"><v-icon>view_list</v-icon>View Records</v-btn>
                </v-card-actions>
            </v-card>


            <v-card class="no-print d-none d-md-flex">
               <v-btn v-on:click="downloadTemplate()"><v-icon>download</v-icon> Download Template</v-btn>
               <v-btn class="ml-1 ies-coral" v-on:click="resetForm()" v-if="permission"><v-icon>cancel</v-icon> Reset</v-btn>
               <v-btn class="ml-1" v-on:click="listView()"><v-icon>view_list</v-icon> List</v-btn>
               <v-btn class="ml-1" v-on:click="emailLink()"><v-icon>email</v-icon> Email</v-btn>
               <v-btn class="ml-1" v-on:click="reportProblem()"><v-icon>report_problem</v-icon> Problem</v-btn>
           </v-card>

       </form>

        <v-snackbar
        :timeout="parseInt(6000)"
        v-model="successSnackbar"
        multi-line
        color="ies-green"
        > 
           <div class="full-height full-width v-align-container text-xs-center">
              <h4 class="ies-dark-gray--text v-align-div">Record Saved</h4>
           </div>
        </v-snackbar>
        <v-snackbar
        :timeout="parseInt(6000)"                          
        v-model="errorSnackbar"
        multi-line
        color="ies-coral"
        > 
           <div class="full-height full-width v-align-container text-xs-center">
              <h4 class="ies-dark-gray--text v-align-div">Save Failed</h4>
           </div>
        </v-snackbar>
    </v-container>
</template>


<script>
    import axios from 'axios';

export default {
    name: 'import',
    props: ['page', 'sectionsData','resultsData', 'permission', 'metadata'],
    data () {
        return {
            errorSnackbar:   false,
            successSnackbar: false,
            pageRecord:      {},
            formSections:    [],
            isBroken:        false,
            csvToUpload: {},
            stage: 'choose',
            uploadResponse: null,
            validation: {},
            import: {}
        }
    },

    methods: {

        /**
         * @method fieldInfo
         *
         * Returns human readable information concerning the given field
         */
        fieldInfo(field){
            var self = this;
            var dataType = this.dataTypeAsString(field.schema.dataType);
            var validation = "";

            if (field.validation.length){
                field.validation.forEach(function(rule){
                    validation += (validation ? ', ' : '' ) + self.validationRuleAsString(rule);
                });

                validation = "Rules: " + validation;
            }

            return (field.schema.mandatory ? '*' : '') + field.schema.displayName + " (" + dataType + ") " + validation;
        },


        dataTypeAsString(dataType){
            switch(dataType){
                case 'varchar':
                    return 'text';
            }
            return dataType;
        },

        // This is a copy of the ones in the input fields
        // @todo make a different module which can be imported and reused in all of them
        validationRuleAsString(rule){
            console.log("explain rule");
            var explainer = '';
            switch(rule.ruleType){
                case 'minLength': explainer = "The text must be at least " + rule.value + " characters long"; break;
                case 'maxLength': explainer = "The text must not be more than " + rule.value + " characters long"; break;
                case 'minValue': explainer = "The value must be more than " + rule.value; break;
                case 'maxValue': explainer = "The value must be less than " + rule.value; break;
                case 'notEmpty': explainer = "The field must not be empty"; break;
                case 'regExp': explainer = "Pattern: " + rule.value; break;
                default:
                    explainer = rule.ruleType + ' ' + rule.value;
            }
            console.log(explainer);
            return explainer;
        },

        /**
         * @method listView
         *
         * Establish the URL to which the user should be sent when requesting a corresponding
         * list page for this page
         */
        listView(){
            // Check if there are unsaved changes
            var listUrl = '/';
            if (!this.unsavedChanges || confirm('If you leave this page before saving you will lose your changes')){
                // @todo is this if clause needed or is it only the else clause?
                if (window.location.pathname.includes('create')){
console.log("A", this.pageRecord);
                    listUrl = this.populateUrlFromThisUrl(this.pageRecord.list_url, this.pageRecord.create_url);
                }
                else {
console.log("B", this.pageRecord);
                    listUrl = this.populateUrlFromThisUrl(this.pageRecord.list_url, this.pageRecord.list_url);
                }

                console.log("will redirect to list view: ", listUrl);
                window.location.assign(listUrl);
            }
        },

        populateUrlFromThisUrl(urlPattern, thisUrlPattern)
        {
            console.log("Will populate the url ", urlPattern, "from current url using pattern ", thisUrlPattern);
            var url = urlPattern;
            var find = [];
            var replace = [];
            var thisUrlPatternParts = thisUrlPattern.split('/');
            var thisUrlParts = window.location.pathname.replace(/^\/|\/$/g, '').split('/');
            console.log(thisUrlPatternParts, thisUrlParts);

            // Extract data from the current page url by analysing it according
            // to whatever pattern it is following - data will be in the bits
            // where the base pattern contains placeholder tags {xyz}
            for(var index = 0; index < thisUrlPatternParts.length; index++){
                if (thisUrlPatternParts[index].includes('{')){
                    find.push(thisUrlPatternParts[index]);
                    replace.push(thisUrlParts[index]);
                }
            }
            console.log(find, replace, url);

            // Replace any of the placeholder tags found in the template with the corresponding values
            for(var index = 0; index < find.length; index++){
                url = url.replace(find[index], replace[index]);
            }
            return url;
        },

        /**
         * @method emailLink
         * 
         * Formats an email to conveniently link the page to an email recipient in the users default email client
         */
        emailLink(){
            var emailAddress = '';
            var subject      = 'Re: ' + this.pageRecord.page_name;
            var body         = 'URL: ' + window.location.href;
            var url          = 'mailto:' + emailAddress + '?subject=' + subject + '&body=' + body;
            window.location.assign(url);
        },


        /**
         * @method reportProblem
         * 
         * Formats an email to conveniently link the page to an email recipient in the users default email client
         */
        reportProblem(){
            var emailAddress = 'web@i-escape.com';
            var subject      = 'Problem Report: ' + this.pageRecord.page_name;
            var body         = 'URL: ' + window.location.href;
            var url          = 'mailto:' + emailAddress + '?subject=' + subject + '&body=' + body;
            window.location.assign(url);
        },

        resetForm: function(){
            this.stage = 'choose';
        },


        fileSelected: function($event){
            this.csvToUpload = { 'name': 'datafile', 'file': event.target.files[0]};
        },

        downloadTemplate: function()
        {
            window.location = window.location.href + '?format=csv';
        },

        /**
         * @method uploadFile
         *
         * @param event 
         */
        uploadFile: function(event){
            var self = this;
            var payload = new FormData();
            payload.append(/*this.csvToUpload.file.name*/ 'uploadFile', this.csvToUpload.file);

            axios.post(window.location.pathname + '?task=upload', payload)
                .then(response => {
                    self.stage = 'validated';
                    self.uploadResponse = response.data;
                    console.log(self.uploadResponse);
                    self.stage = 'confirm';
            }).catch(function (error) {
                    alert("File Upload Error: " + error);
                }
            );
        },

        /**
         * @method confimrImport
         *
         */
        confirmImport: function(){
            axios.post(window.location.pathname + '?task=import&uploadID=' + this.uploadResponse.uploadID)
                .then(response => {
                    this.stage = 'complete';
                    this.import = response.data;
                    console.log(this.import);
                    alert(this.import.message);
            }).catch(function (error) {
                    alert("Import Failed: " + error);
                }
            );

            this.stage = 'complete';
        }

    },

    computed:{
        uxStage: function(){
            console.log(this.stage);
            return this.stage;
        }
    },

    // All initialisation actions that should be performed on page ready
    mounted: function () {
        try{
            console.log("Import form created:", this);
            var _this = this;
            this.pageRecord = JSON.parse(this.page);
            this.formSections = this.sectionsData;
            console.log("sections: ", this.formSections);
        } catch(exception){
            console.log(exception);
            this.isBroken = true;
        }
        console.log("IMPORT mounted, page record: ", this.pageRecord);
    }
}
</script>

<style>
    .ies-actions td:first-child{
        padding:0px;
    }

    input:disabled {
        background: #dddddd;
    }

    table.sample {
        border: solid 1px darkgray;
    }

    table.sample tr td {
        border: solid 1px darkgray;
        padding: 1rem;
    }

    .is-invalid {
        background-color: #FFBBBB;
    }

    .is-headings {
        background-color: lightgray;
    }

    .is-not-relevant {
        background-color: gray;
    }
</style>
